


































































































































































































































import { Component, Prop, Vue, Watch, PropSync } from "vue-property-decorator";
import _ from "lodash";
import { DxButton } from "devextreme-vue/ui/button";
import DSelectbox from "@/components/DSelectbox/selectbox.vue";
import { DxPopup } from "devextreme-vue";
import DTextbox from "@/components/DTextbox/textbox.vue";
import DTagbox from "@/components/DTagbox/tagbox.vue";
import DxScrollView from 'devextreme-vue/scroll-view';
import { DxCheckBox } from "devextreme-vue/check-box";
import {CutHistoryContentType, CutHistoryType, CutType, CutWithAccept, EcoVersionType} from "@/services/models-service";
import { type_cut } from "@/constants";
import { YearType, FacilityType } from "@/services/models-service";
import YearService from "@/services/years-service";
import CutService from "@/services/cut-service";
import FilialService, { Filial } from "@/services/data/filial_service";
import FacilityService from "@/services/data/facility_service";
import { confirm } from "devextreme/ui/dialog";
import CutHistoryService from "@/services/cut-history-service";
import EcoVersionService from "@/services/eco-versions-service";
import EcoObjectsService from "@/services/eco-objects-service";


@Component({
  name: "CutHistoryDetailPopup",
  components: {
    DxButton,
    DSelectbox,
    DxPopup,
    DTextbox,
    DxCheckBox,
    DTagbox,
    DxScrollView
  }
})
export default class extends Vue {
  @PropSync('popupOptions') public localPopupOptions: any;

  public all_years: YearType[] = [];

  private localTypeCut = type_cut;

  private allFilial: Filial[] = [];
  private allFacility: any = [];

  private cutsBusiness: CutType [] = [];
  private cutsFacts: CutType [] = [];
  private current_cuts: CutType [] = [];

  private cut_content: CutHistoryContentType = new CutHistoryContentType();

  public service = CutHistoryService;
  public ecoVersion: EcoVersionType [] | null = null;

  get actionType() {
    return String(this.service.current?.crud_type)
  }


public copy_left_values =  [
    {name: 'copy_shop_value', title: "Покупка. Значения"},
    {name: 'copy_realization_value', title: "Реализация. Значения"},
    {name: 'copy_transport_expenses_value', title: "Транспорт, затраты. Значения"},
    {name: 'copy_transport_revenue_value', title: "Транспорт, выручка. Значения"},
    {name: 'copy_ok_xn_loss_value', title: "ОК/ХН/Потери. Значения"},
];

  public copy_right_values = [
    {name: 'copy_tariffs_value', title: "Тарифы. Значения"},
    {name: 'copy_objects', title: "Объекты. Настройка блоков"},
    {name: 'copy_fb_use_leave', title: "ФБ-02. Полезный отпуск"},
    {name: 'copy_fb_tec_loses', title: "ФБ-02. Тех. потери"},
    {name: 'copy_fb_com_loses', title: "ФБ-02. Ком. потери"},
    {name: 'copy_grouped_objects', title: "Сводные данные. Групповые объекты"},
];

  public months = [
    {name: 'january', title: "Янв"},
    {name: 'february', title: "Фев"},
    {name: 'march', title: "Мар"},
    {name: 'april', title: "Апр"},
    {name: 'may', title: "Май"},
    {name: 'june', title: "Июн"},
    {name: 'july', title: "Июл"},
    {name: 'august', title: "Авг"},
    {name: 'september', title: "Сен"},
    {name: 'october', title: "Окт"},
    {name: 'november', title: "Ноя"},
    {name: 'december', title: "Дек"},
  ]

  public visibleForOptions = [
    { value: 'Видимый для администратора', label: 'Видимый для администратора' },
    { value: 'Видимый для всех', label: 'Видимый для всех' },
    { value: 'Скрыт для всех', label: 'Скрыт для всех' },
  ];


  async created() {
    this.all_years = YearService.YearList;
    if (this.service.current?.content) {
      this.cut_content = _.cloneDeep(this.service.current?.content);

    } else {
      this.cut_content = new CutHistoryContentType();
    }

    const resp2 = await EcoVersionService.get();
    if (resp2.data) {
      this.ecoVersion = resp2.data;
    }

  }

  async mounted() {

  }

  isCreatedLog(){
    return this.localPopupOptions.title === "Лог создания срезки"
  }

  isChanged(field_name: string) {
    return this.cut_content?.old && this.cut_content.old.hasOwnProperty(field_name);
  }

  oldValue(field_name: string) {
    if (this.isChanged(field_name)) {
      return `Прежнее значение: ${this.cut_content.old[field_name]}`;

    }
  }

async onShowing() {


    const response = await CutService.getWithFilter(this.cut_content.new.id_year);
        if (response.data) {
            this.current_cuts = response.data
        }
}

onShow() {

}



onClose() {
    this.localPopupOptions.visible = false;
}

clearCopyData() {

}



}
